import block from 'bem-cn';
import './BookingCompletedForm.scss';

const b = block('BookingCompletedForm');

const BookingCompletedForm = () => {
  return (
    <form className={b()}>
      <div className={b('wrapper')}>
        <h2 className={b('caption')}>Бронировать</h2>
        <div className={b('text-wrapper')}>
          <span className={b('text')}>
            Спасибо! Данные успешно отправлены.
            Скоро наш менеджер свяжется с Вами.</span>
        </div>
      </div>
    </form>
  );
}

export default BookingCompletedForm;